
import PhotoSwipe from 'photoswipe/dist/photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default';

class Gallery {

    constructor( $elem ) {

        this.$elem = $elem;
        this.$tiles = this.$elem.find('[data-gallery-tile]');
        this.$pswp = this.$elem.find('[data-gallery-pswp]');

        this.data = this.get_data();

        this.$tiles.on( 'click', ( e ) => {
            e.preventDefault();
            this.open( $(e.currentTarget) );
        } );

    }

    get_data() {

        let data = [];

        this.$tiles.each( ( index, tile ) => {

            const $tile = $(tile);

            data.push({
                src: $tile.data('image'),
                w: $tile.data('width'),
                h: $tile.data('height'),
                msrc: $tile.data('small-image'),
                title: $tile.data('caption')
            });

        } );

        return data;

    }

    open( $tile ) {

        const gallery = new PhotoSwipe( this.$pswp[0], PhotoSwipeUI_Default, this.data, {
            history: false,
            index: $tile.data('gallery-tile'),
            showHideOpacity: true
        } );

        gallery.init();

    }

}

$('[data-gallery]').each( function( index, elem ){
    new Gallery( $(elem) );
} );